import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

export interface IIconProps extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  size?: number;
  color?: string;
  icon: React.ReactType;
  className?: string;
}

export const IconComp: React.FC<IIconProps> = (props) => {
  const { size, color, icon, style: styleArg, ...svgProps } = props;
  const svgExtraProps: { width: string; height: string; style: typeof styleArg } = {
    width: '',
    height: '',
    style: {},
  };

  if (size !== undefined) {
    svgExtraProps.width = `${size}px`;
    svgExtraProps.height = `${size}px`;
  } else {
    // default
    svgExtraProps.width = '24px';
    svgExtraProps.height = '24px';
  }

  if (color !== undefined) {
    svgExtraProps.style = { color, ...styleArg };
  }
  const Icon: React.ReactType = icon;
  return <Icon {...svgProps} {...svgExtraProps} />;
};
